
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';

import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
import useEstudiando from '../hooks/useEstudiando';
import FlexCenter from './FlexCenter';

const Estudiando = () => {

    const { cargando, estudiosActuales, estaEstudiando, setEstaEstudiando, guardarEstudiando,
            formEstudios, setFormEstudios, llenarFormEstudios, cerrarModal, isOpen, editarEstudiando,
            borrarEstudiando } = useEstudiando();

    function tablaEstudiosActuales() {
        if ( estaEstudiando ) {
            return (
                <>
                    <Alert variant='success' className='my-4'>
                        Si estás estudiando completa los siguientes campos.
                    </Alert>
                    <div className='card card-body'>
                        <Row>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    label="Institución"
                                    className="mb-3"
                                    controlId="floatingInput13"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formEstudios.institucion }
                                        onChange={ e => setFormEstudios({ ...formEstudios, institucion: e.target.value }) }
                                />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput12"
                                    label="Carrera"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formEstudios.carrera }
                                        onChange={ e => setFormEstudios({ ...formEstudios, carrera: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>
                        <FlexCenter>
                            <Button
                                variant="primary"
                                disabled={ cargando }
                                onClick={ guardarEstudiando }
                            >
                                { ( cargando ) ? "Guardando" : "Guardar cambios" }
                            </Button>
                        </FlexCenter>
                    </div>
                    <div className='table-responsive my-4'>
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th className='text-center'>Institución</th>
                                    <th className='text-center'>Carrera</th>
                                    <th className='text-center'>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                { estudiosActuales?.map(( e, i )=> (
                                    <tr key={ i }>
                                        <td className='text-center'>
                                            { e.institucion }
                                        </td>
                                        <td className='text-center'>
                                            { e.carrera }
                                        </td>
                                        <td className='text-center'>
                                            <ButtonGroup>
                                                <TooltipHover tooltipText='Editar información'>
                                                    <Button variant='warning' onClick={ () => llenarFormEstudios( e ) }>
                                                        <PencilIcon/>
                                                    </Button>
                                                </TooltipHover>
                                                <TooltipHover tooltipText='Eliminar'>
                                                    <Button variant='danger' onClick={ () => borrarEstudiando( e.pk_estudiando ) }>
                                                        <DeleteIcon/>
                                                    </Button>
                                                </TooltipHover>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </>
            )
        }
    }



    return (
        <div className="my-4">

            <p className="lead text-center">
                ¿Está estudiando?
            </p>

            <Form.Check
                id = 'sigue_estudiando'
                type = 'checkbox'
                className = 'd-flex justify-content-center no-select'
                checked = { estaEstudiando }
                onChange = { e => setEstaEstudiando( e.target.checked ) }
                label = '&nbsp;&nbsp;Marcar en caso de seguir estudiando'
            />

            { tablaEstudiosActuales() }

            <Modal
                show={ isOpen }
                onHide={ cerrarModal }
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className=''
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Administrar registros</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Row>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                label="Institución"
                                className="mb-3"
                                controlId="floatingInput14"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formEstudios.institucion }
                                    onChange={ e => setFormEstudios({ ...formEstudios, institucion: e.target.value }) }
                            />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput15"
                                label="Carrera"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formEstudios.carrera }
                                    onChange={ e => setFormEstudios({ ...formEstudios, carrera: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={ cerrarModal }>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={ editarEstudiando } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </Modal.Footer>
            </Modal>

            <hr className='m-5'/>
        </div>
    )
}

export default Estudiando
